export const API = process.env.NEXT_PUBLIC_API_URL;
export const BLOB_URL = process.env.NEXT_PUBLIC_BLOB_URL;
export const WEB_URL = process.env.NEXT_PUBLIC_WEB_URL;
export const STATIC_IMG = (fileName: string) =>
  `https://tralsterappfiles.blob.core.windows.net/static/${fileName}`;
